export const getStyles = () => {
    const styles = {
        svgIcon: {
            fontSize: 26
        },
        tebleRow: {
            textDecoration: 'none',
            width: '100%',
        },
        text: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
            lineHeight: 1.2,
        },
        title: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
            lineHeight: 1.2,
        },
        cell: {
            py: 1
        },
    };
    return styles;
};